import React from "react";

const AnimalNonCertifiedBadge: React.FC = () => (
  <span
    title="Animal-derived stock awaiting certification"
    className="inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-orange-50 text-orange-800 border border-orange-200"
  >
    Animal (Non-Certified)
  </span>
);

export { AnimalNonCertifiedBadge };
